import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild
} from '@angular/core';
import { CustomerBannerData } from '@models/customer-banner';
import { DataLayerService } from '@services/data-layer/data-layer.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router , RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-customer-banner',
  templateUrl: './customer-banner.component.html',
  styleUrls: ['./customer-banner.component.scss'],
})
export class CustomerBannerComponent implements OnInit, AfterViewInit, OnDestroy {
  private resizeObserver!: ResizeObserver;
  @Input() customerBannerData: CustomerBannerData;
  @Input() policyTypes: any;
  @Input() appliedContentHeight: number;
  @Input() appliedBannerHeight: number;
  @Output() contentHeight: EventEmitter<number> = new EventEmitter();
  @ViewChild('contentRef') contentRef!: ElementRef<HTMLDivElement>;
  @ViewChild('btnRef') btnRef!: ElementRef<HTMLDivElement>;
  @ViewChild('titleRef') titleRef!: ElementRef<HTMLDivElement>;
  @ViewChild('infoRef') infoRef!: ElementRef<HTMLDivElement>;
  bannerImage: string;
  safeTitle: SafeHtml;
  safeContent: SafeHtml;
  bannerContentHeight: number;
  bannerImageHeight: number;
  maxBannerWidth: number;

  titleStyle: any = {};
  infoStyle: any = {};
  buttonStyle: any = {};

  constructor(
    private dataLayer: DataLayerService,
    private sanitizer: DomSanitizer,
     private router: Router
  ) { }

  ngOnInit(): void {
     this.safeContent = this.customerBannerData?.contentText;
    this.safeTitle = this.customerBannerData?.titleText;
    if (this.customerBannerData?.embeddedImage && this.customerBannerData?.embeddedImage.bgImage) {
      this.bannerImage = 'data:image/' + this.customerBannerData?.embeddedImage?.fileExtn
        + ';base64,' + this.customerBannerData?.embeddedImage?.bgImage;
    } else {
      this.bannerImage = 'data:image/png;base64,' + this.customerBannerData?.bgImage;
    }

    this.setStyles();
  }

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      this.calculateContentHeight();
      this.trackBannerImpression();
    });
    if (window.innerWidth > 767) {
      this.resizeObserver = new ResizeObserver(() => {
        this.maxBannerWidth = this.customerBannerData?.embeddedImage
          ? Number(this.customerBannerData.embeddedImage?.width) : null
        const maxImageHeight = this.customerBannerData.embeddedImage
          ? Number(this.customerBannerData.embeddedImage?.height) : 217
          this.bannerContentHeight = maxImageHeight;
          this.bannerImageHeight = maxImageHeight;
      })
 
      this.resizeObserver.observe(this.contentRef.nativeElement);
    } else {
      this.bannerContentHeight = Math.max(this.appliedContentHeight, 188);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  onClick(label): void {
    const event = {
      name: 'click_link',
      category: 'remarked content',
      detail: 'click banner',
      label: label
    }
    this.dataLayer.pushEvent(event);
    if (this.customerBannerData.hyperLinkUrl.startsWith('http')) { 
     window.open(this.customerBannerData.hyperLinkUrl, '_blank'); 
    } else {
      this.router.navigate([this.customerBannerData.hyperLinkUrl]); 
    }
  }

  private trackBannerImpression(): void {
    if (!this.customerBannerData) {
      return;
    }

    const event = {
      name: 'click_link',
      category: 'carousel',
      detail: 'impression banner',
      label: this.customerBannerData.eventLabelGA
    };

    this.dataLayer.pushEvent(event);
  }


  setStyles() {
    this.titleStyle = {
      'font-size': this.customerBannerData?.titleTextFontSize || null,
      'line-height': this.customerBannerData?.titleTextLineHeight || null,
      'color': this.customerBannerData?.titleTextColor || null,
      'max-width': this.customerBannerData?.titleMaxWidth || null
    }

    this.infoStyle = {
      'letter-spacing': this.customerBannerData?.letterSpacing || null,
      'color': this.customerBannerData?.contentTextColor || null,
      'font-size': this.customerBannerData?.contentTextFontSize || null,
      'margin-top': this.customerBannerData?.contentTextMarginTop || null,
      'line-height': this.customerBannerData?.contentTextLineHeight || null,
      'max-width': this.customerBannerData?.contentMaxWidth
    }

    this.buttonStyle = {
      'background-color': this.customerBannerData?.hyperLinkBackgroundColor || null,
      'color': this.customerBannerData?.hyperLinkTextColor || null,
      'font-size': this.customerBannerData?.hyperLinkTextFontSize || null
    }
  }

  private calculateContentHeight() {
    const totalContentHeight = this.titleRef.nativeElement?.offsetHeight + this.infoRef.nativeElement?.offsetHeight + 8;
    this.contentHeight.emit(totalContentHeight);
  }
}
